import Base from 'app/views/base';

import { presentModal, closeModal } from 'utils/modal';

export default Base.extend({
  className: 'modal fade',
  attributes: {
    tabindex: '-1',
  },
  modalOptions: {},

  show() {
    this.delegateEvents();
    this.render();
    this.modal = presentModal(this.$el, this.modalOptions);
    this.trigger('shown');
    return this;
  },

  close(optionalEvent) {
    if (optionalEvent) {
      optionalEvent.preventDefault();
    }

    closeModal(this.$el);
    this.$el.on('hidden.bs.modal', () => this.trigger('closed'));

    return this;
  },
});



// WEBPACK FOOTER //
// ./app/views/modals/base_modal.js